import { createApp } from 'vue';
import http from './plugins/http';
import CheckoutApp from '../components/checkout/Checkout.vue';

const el = document.getElementById('vCheckout');

if( el ) {

    const {
        productId,
        productSlug,
        productName,
        price,
        isAuth,
        userEmail,
        userName,
        accessType,
        hasPass,
        isMax,
        credits,
        cost,
    } = el.dataset;

    createApp( CheckoutApp, {
        productId     : Number( productId ),
        productSlug    : productSlug,
        productName    : productName || '',
        price          : Number( price ),
        isAuth         : isAuth === '1',
        userEmail      : userEmail || '',
        userName       : userName  || '',
        accessType     : accessType || '',
        hasPass        : hasPass === '1',
        isMax          : isMax === '1',
        creditsBalance : Number( credits || 0 ),
        cost           : Number( cost || 0 ),
    }).use(http).mount(el);
}